import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToTimecodeTap = (
    timecodeTap$: Observable<void>,
    playbackStore: IPlaybackStore
): Subscription =>
    timecodeTap$
        .subscribe(() => playbackStore.actions.toggleTimecodeMode());

export default subscribeToTimecodeTap;